import { IVerb } from '../resources/istatement/verb';
import { LanguageMap } from '../resources/istatement/language_map';
import { Utils } from '../utils';
import { Versions } from '../constants/versions';

const _downConvertMap: { [key: string]: string } = {
	'http://adlnet.gov/expapi/verbs/experienced': 'experienced',
	'http://adlnet.gov/expapi/verbs/attended': 'attended',
	'http://adlnet.gov/expapi/verbs/attempted': 'attempted',
	'http://adlnet.gov/expapi/verbs/completed': 'completed',
	'http://adlnet.gov/expapi/verbs/passed': 'passed',
	'http://adlnet.gov/expapi/verbs/failed': 'failed',
	'http://adlnet.gov/expapi/verbs/answered': 'answered',
	'http://adlnet.gov/expapi/verbs/interacted': 'interacted',
	'http://adlnet.gov/expapi/verbs/imported': 'imported',
	'http://adlnet.gov/expapi/verbs/created': 'created',
	'http://adlnet.gov/expapi/verbs/shared': 'shared',
	'http://adlnet.gov/expapi/verbs/voided': 'voided'
};

export interface VerbParams extends IVerb {
	[key: string]: any;
}

export class Verb implements IVerb {
	id: string;
	display: LanguageMap;

	constructor(cfg: string | IVerb) {
		/**
	@property id
	@type String
	*/
		this.id = '';

		/**
	@property display
	@type Object
	*/
		this.display = {};

		this.init(cfg);
	}

	init(cfg: string | VerbParams): void {
		const directProps = ['id', 'display'];

		if (typeof cfg === 'string') {
			this.id = cfg;
			this.display = {
				und: this.id
			};

			//If simple string like "attempted" was passed in (0.9 verbs),
			//upconvert the ID to the 0.95 ADL version
			for (const prop in _downConvertMap) {
				if (_downConvertMap[prop] === cfg) {
					this.id = prop;
					break;
				}
			}
		} else {
			cfg = cfg || {};
			for (const prop of directProps) {
				if (cfg[prop]) {
					(this as any)[prop] = cfg[prop];
				}
			}

			if (Object.keys(this.display).length === 0 && typeof _downConvertMap[this.id] !== 'undefined') {
				this.display = {
					und: _downConvertMap[this.id]
				};
			}
		}
	}

	toString(lang?: string): string | null {
		if (this.display !== null) {
			return this.getLangDictionaryValue('display', lang);
		}

		return this.id;
	}

	/**
	@method asVersion
	@param {String} [version] Version to return (defaults to newest supported)
	*/
	asVersion(version: Versions = '1.0.3'): IVerb {
		const { id, display } = this;
		const result: IVerb = {
			id,
			display
		};

		return result;
	}

	getLangDictionaryValue = Utils.getLangDictionaryValue;

	static fromJSON(verbJSON: string): Verb {
		const _verb = JSON.parse(verbJSON);
		return new Verb(_verb);
	}
}
